import ConnectionsPage from "@/components/site-settings/ConnectionsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/site-settings/connections",
)({
  component: ConnectionsPage,
});
